import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { slotsAPI, usersAPI } from '../services/api';
import type { TrainingType } from '../types';
import EventsTab from '../components/admin/EventsTab';
import UsersTab from '../components/admin/UsersTab';

type TabType = 'events' | 'users';

const Admin: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('events');

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Admin Panel</h1>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('events')}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'events'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Events & Bookings
          </button>
          <button
            onClick={() => setActiveTab('users')}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'users'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Users Management
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'events' && <EventsTab />}
      {activeTab === 'users' && <UsersTab />}
    </div>
  );
};

export default Admin;
